module.exports = __webpack_public_path__ + "static/img/sh_bck.cca6ede7.png";